import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import { Link } from "react-router-dom";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons/faUserAlt";
import jwt_decode from "jwt-decode";
import setAuthToken from "../../../src/utils/setAuthToken";
import { setCurrentUser } from "../../../src/actions/authActions";
import Loading from "../layout/Loading";
import axios from "axios";
import Moment from "moment";

import * as myConstList from "../../BaseUrl";
import MetaTags from "react-meta-tags";
import socketIOClient from "socket.io-client";

import $ from "jquery";

const jwtToken = localStorage.getItem("jwtToken");
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;
const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liveContestStartRecords: "",
      liveContestEndRecords: "",
      balance: 0,
      upcomingTotal: 0,
      pastTotal: 0,
      liveTotal: 0,
      winningamount: 0,
      kycCompleteStatus: "",
      isUserContestActive: false,
      //  loginHostory:[],
      errors: {},
      endDays: 0,
      endHours: 0,
      endMinutes: 0,
      endSeconds: 0,
      startDays: 0,
      startHours: 0,
      startMinutes: 0,
      startSeconds: 0,
      banner: [],
      urltemp: "",
      thirdPhaseConfig: "",
      bannerDisplay: "",
      coinUpcomingTotal: 0,
      coinPastTotal: 0,
      coinLiveTotal: 0,

      priceUpcomingTotal: 0,
      pricePastTotal: 0,
      priceLiveTotal: 0,

      forecastingUpcomingTotal: 0,
      forecastingPastTotal: 0,
      forecastingLiveTotal: 0,
      loadingProcess: true,
      themeSet: "",
    };

    clearInterval();
    // window.location.reload();
  }

  componentDidMount() {
    this.getMemberShipDetails();

    var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({
        urltemp: urltemp,
        themeSet: localStorage.getItem("theme"),
      });
    }

    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location;
    }

    const params = new Proxy(
      new URLSearchParams(this.props.history.location.search),
      {
        get: (searchParams, prop) => searchParams.get(prop),
      }
    );
    let source = params.source;
    let theme = params.theme;
    if (source === "mobile" && theme === "d") {
      $("body").addClass("darkclass");
    } else {
      $("body").removeClass("darkclass");
    }

    this.intervalDadhboardTimer = setInterval(() => {
      if (this.state.liveContestEndRecords !== null) {
        const EndDateTime =
          this.state.liveContestEndRecords.endDate +
          " " +
          this.state.liveContestEndRecords.endTime;
        var expriry = new Date(EndDateTime);
        var dateformat = this.state.serverTime;
        var currentDate = new Date(dateformat);
        expriry = Date.parse(expriry);
        expriry = expriry / 1000;
        currentDate = Date.parse(currentDate);
        currentDate = currentDate / 1000;
        const countdown = Moment(expriry - currentDate);
        var duration = Moment.duration(countdown * 1000, "milliseconds");
        var interval = 1000;
        duration = Moment.duration(duration - interval, "milliseconds");

        const endDays = duration.days();
        const endHours = duration.hours();
        const endMinutes = duration.minutes();
        const endSeconds = duration.seconds();

        this.setState({
          endDays: endDays,
          endHours: endHours,
          endMinutes: endMinutes,
          endSeconds: endSeconds,
        });
      }

      if (this.state.liveContestStartRecords !== null) {
        // StartDateTime Duration
        const startDateTime = Moment.utc(
          this.state.liveContestStartRecords.startDate
        ).format("YYYY-MM-DD HH:mm");
        var expriry = new Date(startDateTime);
        var dateformat = this.state.serverTime;
        var currentDate = new Date(dateformat);

        expriry = Date.parse(expriry);
        expriry = expriry / 1000;
        currentDate = Date.parse(currentDate);
        currentDate = currentDate / 1000;
        const countdown1 = Moment(expriry - currentDate);
        var duration = Moment.duration(countdown1 * 1000, "milliseconds");
        var interval = 1000;
        duration = Moment.duration(duration - interval, "milliseconds");

        const startDays = duration.days();
        const startHours = duration.hours("HH");
        const startMinutes = duration.minutes("mm");
        const startSeconds = duration.seconds("SS");
        this.setState({ startDays, startHours, startMinutes, startSeconds });
      }
    }, 1000);

    const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
    this.setState({ socketCollect: socket });
    var collectThis = this;

    // client-side

    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("callDashboardData");
    });
    socket.emit("config3rdphase");
    socket.on("3rdPhaseConfig", function (apiRespData) {
      console.log("apiRespData==", apiRespData);
      if (socket.id == collectThis.state.currentSocketId) {
        var arr = [];
        arr["account"] = apiRespData.data[0].account;
        arr["transaction"] = apiRespData.data[0].transaction;
        collectThis.setState({
          thirdPhaseConfig: arr,
          bannerDisplay: apiRespData.data[0].banner,
          community_contest: apiRespData.data[0].community_contest,
          predictionManagement: apiRespData.data[0].predictionManagement,
          loadingProcess: false,
        });
      }
    });

    socket.on("serverTime", function (apiRespData) {
      // console.log("apiRespData==",apiRespData);
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({ serverTime: apiRespData });
      }
    });

    socket.on("totalContestData", function (apiRespData) {
      // console.log("totalContestData===",apiRespData);
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({
          upcomingTotal: apiRespData.data.upcomingtotal,
          pastTotal: apiRespData.data.pastTotal,
          liveTotal: apiRespData.data.liveTotal,
        });
      }
    });
    socket.on("totalPredictionContestData", function (apiRespData) {
      // if (socket.id == collectThis.state.currentSocketId) {
      collectThis.setState({
        coinUpcomingTotal: apiRespData.data.coinUpcomingtotal,
        coinPastTotal: apiRespData.data.coinPastTotal,
        coinLiveTotal: apiRespData.data.coinLiveTotal,
      });
      // }
    });

    socket.on("totalPriceContestData", function (apiRespData) {
      // if (socket.id == collectThis.state.currentSocketId) {
      collectThis.setState({
        priceUpcomingTotal: apiRespData.data.priceUpcomingtotal,
        pricePastTotal: apiRespData.data.pricePastTotal,
        priceLiveTotal: apiRespData.data.priceLiveTotal,
      });
      // }
    });

    socket.on("totalForcastContestData", function (apiRespData) {
      // console.log("forcasttotalContestData===",apiRespData);
      // if (socket.id == collectThis.state.currentSocketId) {
      collectThis.setState({
        forcastUpcomingTotal: apiRespData.data.forcastUpcomingtotal,
        forcastPastTotal: apiRespData.data.forcastPastTotal,
        forcastLiveTotal: apiRespData.data.forcastLiveTotal,
      });
      // }
    });

    socket.on("profileData", function (apiRespData) {
      // console.log("profileData==",apiRespData.data);
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({
          records: apiRespData.data,
          balance: apiRespData.data.balance,
          winningamount: apiRespData.totalWonContest,
          kycCompleteStatus: apiRespData.data.kycCompleteStatus,
        });
      }
    });

    socket.on("upcomingRecordData", function (apiRespData) {
      if (socket.id == collectThis.state.currentSocketId) {
        if (apiRespData.data.length > 0) {
          collectThis.setState({
            liveContestStartRecords: apiRespData.data[0],
          });
        }
      }
    });

    socket.on("liveRecordDashboardData", function (apiRespData) {
      if (socket.id == collectThis.state.currentSocketId) {
        if (apiRespData.data.length > 0) {
          collectThis.setState({ liveContestEndRecords: apiRespData.data[0] });
        }
      }
    });

    axios
      .post(baseUrl + "api/getBunner", {}, config)
      .then((res) => {
        if (res.data.data.length > 0) {
          this.setState({ banner: res.data.data });
        }
      })
      .catch();
    axios
      .post(baseUrl + "api/save-profile-data", {}, config)
      .then((res) => {
        // console.log("dataataaataataa==",res);
        // if (res.data.data.length > 0) {
        //   this.setState({ banner: res.data.data });
        // }
      })
      .catch();
  }

  getMemberShipDetails = () => {
    axios
      .post(baseUrl + "api/get-membership-details", {}, config)
      .then((res) => {
        var resp = res.data;
        if (resp.status === true) {
          this.setState({ memberShipStatus: "Active" });
        } else {
          this.setState({ memberShipStatus: "Pending" });
        }
      });
  };

  showLiBannerHtml = () => {
    const html = [];
    if (this.state.banner.length > 0) {
      this.state.banner.map(function (value, i) {
        html.push(
          <>
            {" "}
            <li
              data-target="#myCarousel"
              data-slide-to={i}
              className={i === 0 ? "active" : ""}
            ></li>
          </>
        );
      });
    }
    return html;
  };
  showDivBannerHtml = () => {
    const html = [];
    if (this.state.banner.length > 0) {
      this.state.banner.map(function (value, i) {
        html.push(
          <>
            {" "}
            <div className={i === 0 ? "carousel-item active" : "carousel-item"}>
              {/* {!value.banner_image && */}

              <a
                href={value.banner_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={baseUrl + "static/bunner/" + value.banner_image}
                  alt={value.banner_alt_text}
                  className="img-fluid"
                />
              </a>
              {/* } */}
              {/* {value.banner_image ===null &&
             
             <iframe src="https://www.youtube.com/embed/biO6z-pst34" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            } */}
            </div>
          </>
        );
      });
    }
    return html;
  };
  componentWillReceiveProps(nextProps) {
    // if (nextProps.auth.isAuthenticated) {
    //     this.props.history.push("/dashboard");

    // }

    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
  }
  componentWillUnmount() {
    var getSocket = this.state.socketCollect;
    getSocket.emit("disconnectDashboardApi");
    clearInterval(this.intervalDashoard);
    clearInterval(this.intervalDadhboardTimer);
  }

  showTimerCounterEndHtml = () => {
    if (
      this.state.liveContestEndRecords !== null &&
      this.state.liveContestEndRecords._id != "" &&
      this.state.liveContestEndRecords._id != undefined
    ) {
      if (!isNaN(this.state.endDays)) {
        return (
          <>
            <MetaTags>
              <title>3.0 Verse </title>
            </MetaTags>
            <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
              <Link
                className="d_box  bg_red"
                to={
                  this.state.urltemp !== ""
                    ? "/trading-contest/" +
                      this.state.liveContestEndRecords._id +
                      this.state.urltemp
                    : "/trading-contest/" + this.state.liveContestEndRecords._id
                }
              >
                <span className="ttt_box_icon ttt_box_icon1">
                  <i className="las la-trophy"></i>
                </span>
                <div className="d_hadding">
                  {this.state.liveContestEndRecords.contestName}
                  <br />
                  Ends In
                  <div>
                    {this.state.endSeconds > 0 && (
                      <span className="timerdiv">
                        <span className="dhms">
                          {" "}
                          <span className="timercounter">
                            {this.state.endDays}
                          </span>
                          D
                        </span>
                        <span>:</span>
                        <span className="dhms">
                          <span className="timercounter">
                            {this.state.endHours}
                          </span>{" "}
                          H
                        </span>
                        <span>:</span>
                        <span className="dhms">
                          <span className="timercounter">
                            {this.state.endMinutes}
                          </span>
                          M
                        </span>
                        <span>:</span>
                        <span className="dhms">
                          {" "}
                          <span className="timercounter">
                            {this.state.endSeconds}
                          </span>
                          S
                        </span>
                        <span></span>
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            </div>
          </>
        );
      }
    }
  };

  showTimerCounterStartHtml = () => {
    if (
      this.state.liveContestStartRecords != null &&
      this.state.liveContestStartRecords.id != "" &&
      this.state.liveContestStartRecords.id != undefined
    ) {
      return (
        <>
          <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
            <Link
              className="d_box  bg_green"
              to={
                this.state.urltemp !== ""
                  ? "/trading-contest/" +
                    this.state.liveContestStartRecords.id +
                    this.state.urltemp
                  : "/trading-contest/" + this.state.liveContestStartRecords.id
              }
            >
              <span className="ttt_box_icon ttt_box_icon1">
                <i className="las la-trophy"></i>
              </span>
              <div className="d_hadding">
                {" "}
                {this.state.liveContestStartRecords.contestName}
                <br />
                Starts In
                <div>
                  {this.state.startSeconds > 0 && (
                    <span className="timerdiv">
                      <span className="dhms">
                        {" "}
                        <span className="timercounter">
                          {this.state.startDays}
                        </span>
                        D
                      </span>
                      <span>:</span>
                      <span className="dhms">
                        <span className="timercounter">
                          {this.state.startHours}
                        </span>{" "}
                        H
                      </span>
                      <span>:</span>
                      <span className="dhms">
                        <span className="timercounter">
                          {this.state.startMinutes}
                        </span>
                        M
                      </span>
                      <span>:</span>
                      <span className="dhms">
                        {" "}
                        <span className="timercounter">
                          {this.state.startSeconds}
                        </span>
                        S
                      </span>
                      <span></span>
                    </span>
                  )}
                </div>
                {this.state.startSeconds < 0 && "Started"}
              </div>
            </Link>
          </div>
        </>
      );
    }
  };
  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logoutUser();
  };
  tabDashboardClick(tabType) {
    const { user } = this.props.auth;
    window.webengage.track("Virtual Trading_Category Viewed", {
      "Category Name": tabType,
    });
  }
  render() {
    //const { user } = this.props.auth;
    const { error, loadingProcess } = this.state;
    if (loadingProcess) {
      return <Loading themeSet={this.state.themeSet} />;
    }
    return (
      <>
        <Sidebar />
        <Navbar
          urlPath={true}
          symbol={false}
          thirdPhaseConfig={this.state.thirdPhaseConfig}
        />

        <div className="container container2">
          <div className="in_page">
            <h1 className="h3 white_box">VTG Dashboard</h1>
            {this.state.predictionManagement === "1" && (
              <ul className="nav contatcs-tab mb-4">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#PredictionEvent"
                  >
                    Prediction & Event
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#Trading">
                    Trading{" "}
                  </a>
                </li>
              </ul>
            )}

            <div className="tab-content">
              <div
                className={
                  this.state.predictionManagement !== "1"
                    ? "tab-pane active"
                    : "tab-pane"
                }
                id="Trading"
              >
                <div className="row ">
                  {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3"> */}
                  {/* <span   className="d_box ">
								<span className="ttt_box_icon ttt_box_icon1">
                                        <i className="las la-rupee-sign"></i>
                                    </span> */}
                  {/* <Link to="/add-money" className="d_hadding"> */}
                  {/* Cash Wallet 
                                        <div className="d_value">
                                            
                                            {this.state.balance?this.state.balance.toFixed(2):''}
                                        </div>                                    */}
                  {/* </Link> */}

                  {/* </span> */}
                  {/* </div> */}

                  <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <Link
                      to={
                        this.state.urltemp !== ""
                          ? "/contest/live" + this.state.urltemp
                          : "/contest/live"
                      }
                      className="d_box "
                      onClick={() => this.tabDashboardClick("Live Contest")}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-tv"></i>
                      </span>
                      <div className="d_hadding">
                        Universal Live Contest
                        <div className="d_value">{this.state.liveTotal}</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <Link
                      to={
                        this.state.urltemp !== ""
                          ? "/contest/past" + this.state.urltemp
                          : "/contest/past"
                      }
                      className="d_box "
                      onClick={() => this.tabDashboardClick("Past Contest")}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-history"></i>
                      </span>
                      <div className="d_hadding">
                        Past Contest
                        <div className="d_value">{this.state.pastTotal}</div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <Link
                      to={
                        this.state.urltemp !== ""
                          ? "/contest/upcoming" + this.state.urltemp
                          : "/contest/upcoming"
                      }
                      className="d_box "
                      onClick={() => this.tabDashboardClick("Upcoming Contest")}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-calendar"></i>
                      </span>
                      <div className="d_hadding">
                        Upcoming Contest
                        <div className="d_value">
                          {this.state.upcomingTotal}
                        </div>
                      </div>
                    </Link>
                  </div>

                  {this.showTimerCounterEndHtml()}
                  {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <Link
                      className="d_box"
                      to={
                        this.state.urltemp !== ""
                          ? "/winningHistoryTable" + this.state.urltemp
                          : "/winningHistoryTable"
                      } onClick={() => this.tabDashboardClick('Winning Contest')}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-medal"></i>
                      </span>
                      <div className="d_hadding">
                        You Won
                        <div className="d_value">{this.state.winningamount}</div>
                      </div>
                    </Link>
                  </div> */}
                  {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <Link
                      to={
                        this.state.urltemp !== ""
                          ? "/profile-user" + this.state.urltemp
                          : "/profile-user"
                      }
                      className="d_box" onClick={() => this.tabDashboardClick('Wallet Address')}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-wallet"></i>
                      </span>
                      <div className="d_hadding">
                        Wallet Address <br />
                        (Add Wallet)
                      </div>
                    </Link>
                  </div> */}
                  <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                    <a
                      href="https://support.3-verse.io/hc/en-us/articles/6839851031057"
                      className="d_box"
                      onClick={() => this.tabDashboardClick("How to Play")}
                    >
                      <span className="ttt_box_icon ttt_box_icon1">
                        <i className="las la-file-video"></i>
                      </span>
                      <div className="d_hadding">How To Play</div>
                    </a>
                  </div>
                  {this.state.community_contest === "1" && (
                    <>
                      {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                        <Link
                          to={
                            this.state.urltemp !== ""
                              ? "/community-contest/live" + this.state.urltemp
                              : "/community-contest/live"
                          }
                          className="d_box "
                        >
                          <span className="ttt_box_icon ttt_box_icon1">
                            <i className="las la-tv"></i>
                          </span>
                          <div className="d_hadding">
                            Community Contests
                            <div className="d_value">{this.state.comunityTotal}</div>
                          </div>
                        </Link>
                      </div> */}
                      {/* <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                <Link
                    to={
                      this.state.urltemp !== ""
                        ? "/contest/comunity" + this.state.urltemp
                        : "/contest/comunity"
                    }
                  className="d_box "
                >
                  <span className="ttt_box_icon ttt_box_icon1">
                    <i className="las la-tv"></i>
                  </span>
                  <div className="d_hadding">
                    Membership Status
                    <div className="d_value">{this.state.memberShipStatus}</div>
                  </div>
                </Link>
              </div> */}
                    </>
                  )}
                  {this.showTimerCounterStartHtml()}
                </div>
              </div>
              <div
                className={
                  this.state.predictionManagement === "1"
                    ? "tab-pane active"
                    : "tab-pane"
                }
                id="PredictionEvent"
              >
                {/* <div className="d_box"> */}
                <div className="">
                  <ul className="nav contatcs-tab mb-4">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        data-toggle="tab"
                        href="#CoinPrice"
                      >
                        Predict Coin Price
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#PriceTrend"
                      >
                        Predict Price Trend
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-toggle="tab"
                        href="#Forecasting"
                      >
                        Quiz Contest
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div className="tab-pane active" id="CoinPrice">
                      <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/prediction-contest/live/coin" +
                                  this.state.urltemp
                                : "/prediction-contest/live/coin"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Live Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-tv"></i>
                            </span>
                            <div className="d_hadding">
                              Live contests
                              <div className="d_value">
                                {this.state.coinLiveTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/prediction-contest/past/coin" +
                                  this.state.urltemp
                                : "/prediction-contest/past/coin"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Past Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-history"></i>
                            </span>
                            <div className="d_hadding">
                              Past contests
                              <div className="d_value">
                                {this.state.coinPastTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/prediction-contest/upcoming/coin" +
                                  this.state.urltemp
                                : "/prediction-contest/upcoming/coin"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Upcoming Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-calendar"></i>
                            </span>
                            <div className="d_hadding">
                              Upcoming contests
                              <div className="d_value">
                                {this.state.coinUpcomingTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>

                    <div className="tab-pane " id="PriceTrend">
                      <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/price-contest/live/price" +
                                  this.state.urltemp
                                : "/price-contest/live/price"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Live Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-tv"></i>
                            </span>
                            <div className="d_hadding">
                              Live contests
                              <div className="d_value">
                                {this.state.priceLiveTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/price-contest/past/price" +
                                  this.state.urltemp
                                : "/price-contest/past/price"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Past Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-history"></i>
                            </span>
                            <div className="d_hadding">
                              Past contests
                              <div className="d_value">
                                {this.state.pricePastTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/price-contest/upcoming/price" +
                                  this.state.urltemp
                                : "/price-contest/upcoming/price"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Upcoming Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-calendar"></i>
                            </span>
                            <div className="d_hadding">
                              Upcoming contests
                              <div className="d_value">
                                {this.state.priceUpcomingTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane " id="Forecasting">
                      <div className="row">
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/forecasting-contest/live/forcasting" +
                                  this.state.urltemp
                                : "/forecasting-contest/live/forcasting"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Live Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-tv"></i>
                            </span>
                            <div className="d_hadding">
                              Live contests
                              <div className="d_value">
                                {this.state.forcastLiveTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/forecasting-contest/past/forcasting" +
                                  this.state.urltemp
                                : "/forecasting-contest/past/forcasting"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Past Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-history"></i>
                            </span>
                            <div className="d_hadding">
                              Past contests
                              <div className="d_value">
                                {this.state.forcastPastTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <Link
                            to={
                              this.state.urltemp !== ""
                                ? "/forecasting-contest/upcoming/forcasting" +
                                  this.state.urltemp
                                : "/forecasting-contest/upcoming/forcasting"
                            }
                            className="d_box "
                            onClick={() =>
                              this.tabDashboardClick("Upcoming Contest")
                            }
                          >
                            <span className="ttt_box_icon ttt_box_icon1">
                              <i className="las la-calendar"></i>
                            </span>
                            <div className="d_hadding">
                              Upcoming contests
                              <div className="d_value">
                                {this.state.forcastUpcomingTotal}
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
            {this.state.bannerDisplay === "1" && (
              <div className="crypt-market-status2 mt-4 ">
                <div
                  id="myCarousel"
                  className="carousel slide"
                  data-ride="carousel"
                >
                  <ul className="carousel-indicators">
                    {this.showLiBannerHtml()}
                  </ul>
                  <div className="carousel-inner">
                    {this.showDivBannerHtml()}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <Footer />
      </>
    );
  }
}

Dashboard.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Dashboard);
